module.exports = __webpack_public_path__ + "static/media/recovery-cover.e85cc590.png";